import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface CulturalContextProps {
  title: string;
  description: string;
  points: string[];
}

const CulturalContext: React.FC<CulturalContextProps> = ({
  title,
  description,
  points,
}) => {
  return (
    <div className="bg-gradient-to-br from-secondary/5 to-primary/5 rounded-2xl p-8 lg:p-10 border border-secondary/10">
      <div className="flex items-start space-x-5 mb-6">
        <div className="flex-shrink-0 w-12 h-12 bg-secondary/10 rounded-xl flex items-center justify-center">
          <Icon name="BookOpenIcon" size={24} className="text-secondary" />
        </div>
        <div className="flex-1">
          <h3 className="font-playfair text-2xl lg:text-3xl font-semibold text-foreground mb-4">
            {title}
          </h3>
          <p className="font-inter text-base text-muted-foreground leading-relaxed">
            {description}
          </p>
        </div>
      </div>

      <ul className="space-y-4 mt-6">
        {points.map((point, index) => (
          <li key={index} className="flex items-start space-x-4">
            <Icon
              name="CheckCircleIcon"
              size={22}
              className="text-secondary flex-shrink-0 mt-0.5"
            />
            <span className="font-inter text-sm text-foreground leading-relaxed">
              {point}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CulturalContext;